import React, { memo, useMemo } from "react";
import { HappycoWorkOrderFragment } from "gql/graphql";
import colors from "app/colors";
import { Text, HStack, Circle } from "@chakra-ui/react";
import { RoundedTriangleIcon } from "modules/icons";

interface IProps {
  happycoWorkOrder: HappycoWorkOrderFragment;
}

const HappycoWorkOrderPriority = ({ happycoWorkOrder }: IProps) => {
  const bgColor = useMemo(() => {
    switch (happycoWorkOrder.priority) {
      case "URGENT":
        return colors.red30;
      default:
        return colors.gray0;
    }
  }, [happycoWorkOrder.priority]);

  const color = useMemo(() => {
    switch (happycoWorkOrder.priority) {
      case "URGENT":
        return colors.red;
      default:
        return colors.gray50;
    }
  }, [happycoWorkOrder.priority]);

  const icon = useMemo(() => {
    switch (happycoWorkOrder.priority) {
      case "URGENT":
        return <RoundedTriangleIcon boxSize={4} fill={colors.red} />;
      default:
        return <Circle size="10px" bg={colors.gray50} />;
    }
  }, [happycoWorkOrder.priority]);

  const text = useMemo(() => {
    switch (happycoWorkOrder.priority) {
      case "URGENT":
        return "Urgent";
      default:
        return "Normal";
    }
  }, [happycoWorkOrder.priority]);

  if (!happycoWorkOrder.priority) {
    return null;
  }

  return (
    <HStack spacing={1}>
      <Text fontSize={12} fontWeight={500} color={colors.gray50}>
        Priority
      </Text>

      <HStack
        w="80px"
        h="24px"
        bg={bgColor}
        borderRadius={4}
        px={1}
        py="2px"
        justifyContent="center"
        spacing={1}
      >
        {icon}
        <Text fontSize={12} fontWeight={700} color={color}>
          {text}
        </Text>
      </HStack>
    </HStack>
  );
};

export default memo(HappycoWorkOrderPriority);
